import React from 'react';
import dayjs from 'dayjs';
import {
  CalendarDaysIcon,
  BuildingStorefrontIcon,
} from '@heroicons/react/24/outline';
import { TWSelect, TWDateRangePicker } from '../../../components/ui';

const dateOptions = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'weekToD‌​ate', label: 'Week to Date' },
  { value: 'last7Days', label: 'Last 7 Days' },
  { value: 'last14Days', label: 'Last 14 Days' },
  { value: 'last21Days', label: 'Last 21 Days' },
  { value: 'last28Days', label: 'Last 28 Days' },
  { value: 'last30Days', label: 'Last 30 Days' },
  { value: 'monthToD‌​ate', label: 'Month to Date' },
  { value: 'last60Days', label: 'Last 60 Days' },
  { value: 'customRange', label: 'Custom Range' },
];

export default function FilterBar({
  search,
  storeList,
  disabled,
  showCustomRange,
  onRangeSelect,
  onDateChange,
  onStoreSelect,
}) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3">
      <TWSelect
        label="Date range"
        labelIcon={CalendarDaysIcon}
        placeholder="Date range"
        defaultValue={dateOptions.find((a) => a.value === 'last7Days')?.value}
        onChange={(a) => onRangeSelect(a || 'last7Days')}
        options={dateOptions}
      />

      {showCustomRange && (
        <div className="col-span-2 md:col-span-1">
          <TWDateRangePicker
            label="Custom range"
            labelIcon={CalendarDaysIcon}
            value={[
              search.startdate ? dayjs(search.startdate, 'YYYY-MM-DD') : null,
              search.enddate ? dayjs(search.enddate, 'YYYY-MM-DD') : null,
            ]}
            onChange={(e) => (e ? onDateChange(e) : onRangeSelect('last7Days'))}
          />
        </div>
      )}

      <TWSelect
        label="Stores"
        labelIcon={BuildingStorefrontIcon}
        disabled={disabled}
        placeholder="All stores"
        onChange={(e) => onStoreSelect(e)}
        options={storeList.map((a) => ({ label: a.name, value: a.id }))}
        value={search.storeids}
      />
    </div>
  );
}
